import React from "react";
import { Link } from "react-router-dom";

import Button from "../../../components/common/Button";
import Icon from "../../../components/common/Icon";

export default function CTABanner() {
  return (
    <section className="relative overflow-hidden py-16 sm:py-20 lg:py-24">
      <div className="container-page relative">
        <div className="relative overflow-hidden rounded-[2.5rem] border border-white/10 bg-gradient-to-l from-[#0E3A27] via-[#0A2619] to-[#07150F] px-6 py-12 shadow-[0_40px_90px_-34px_rgba(7,21,15,0.8)] sm:rounded-[3rem] sm:px-10 sm:py-16 lg:px-16 lg:py-20">

          <div className="pitch-stripes pointer-events-none absolute inset-0" />
          <div className="pointer-events-none absolute -right-24 top-0 h-80 w-80 rounded-full bg-emerald-500/25 blur-[90px]" />
          <div className="pointer-events-none absolute -bottom-24 left-10 h-72 w-72 rounded-full bg-floodlight/15 blur-[90px]" />
          <div className="pointer-events-none absolute -left-24 top-1/2 h-[380px] w-[380px] -translate-y-1/2 rounded-full border border-white/[0.06]" />

          <div className="relative z-10 grid items-center gap-12 lg:grid-cols-12">

            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 rounded-full border border-floodlight/25 bg-floodlight/10 px-4 py-2 text-[11px] font-black text-floodlight">
                <span className="h-2 w-2 animate-pulse rounded-full bg-floodlight" />
                مرکز فوتبال شهرستان پاوه
              </div>

              <h2 className="mt-6 max-w-3xl text-3xl font-black leading-[1.4] text-white sm:text-4xl lg:text-5xl">
                استعدادهای فوتبال شهر را
                <span className="bg-gradient-to-l from-floodlight via-emerald-300 to-emerald-400 bg-clip-text text-transparent">
                  {" "}
                  بهتر بشناسید
                </span>
              </h2>

              <p className="mt-5 max-w-2xl text-sm leading-8 text-white/55 sm:text-base">
                پروفایل بازیکنان، ترکیب باشگاه‌ها، مسابقات و اخبار رسمی
                فوتبال شهرستان پاوه را در یک محیط یکپارچه دنبال کنید.
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <Button
                  as={Link}
                  to="/players"
                  variant="lime"
                  size="lg"
                  className="min-h-12"
                >
                  کشف بازیکنان
                  <Icon
                    name="users"
                    className="h-5 w-5"
                  />
                </Button>
              </div>
            </div>

            <div className="hidden lg:col-span-4 lg:block">
              <div className="relative mx-auto h-60 w-60">

                <div className="absolute inset-0 animate-[spin_18s_linear_infinite] rounded-full border border-emerald-400/10" />

                <div className="absolute inset-7 rounded-full border border-white/10" />

                <div className="absolute inset-14 rounded-full bg-emerald-400/10 blur-2xl" />

                <div className="absolute inset-0 grid place-items-center">
                  <div className="glass-dark animate-float grid h-32 w-32 place-items-center rounded-[2rem]">
                    <div className="grid h-20 w-20 place-items-center rounded-[1.5rem] bg-gradient-to-br from-floodlight to-emerald-400 shadow-xl shadow-emerald-500/30">
                      <Icon
                        name="users"
                        className="h-9 w-9 text-ink"
                      />
                    </div>
                  </div>
                </div>

                <div className="absolute -right-4 top-6 rounded-2xl glass-dark animate-float-delay px-3 py-2">
                  <div className="flex items-center gap-2">
                    <span className="h-2 w-2 rounded-full bg-emerald-400" />
                    <span className="text-[10px] font-bold text-white">
                      بازیکنان فعال
                    </span>
                  </div>
                </div>

                <div className="absolute -bottom-2 -left-5 rounded-2xl glass-dark animate-float-delay px-3 py-2">
                  <span className="text-[10px] font-bold text-white/70">
                    پروفایل حرفه‌ای
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="relative z-10 mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-white/10 pt-6 text-[10px] font-bold text-white/40">
            <span className="flex items-center gap-2">
              <Icon
                name="shield"
                className="h-3.5 w-3.5 text-emerald-400"
              />
              اطلاعات رسمی
            </span>

            <span className="flex items-center gap-2">
              <Icon
                name="users"
                className="h-3.5 w-3.5 text-lime-400"
              />
              بازیکنان ثبت‌ شده
            </span>

            <span className="flex items-center gap-2">
              <Icon
                name="trophy"
                className="h-3.5 w-3.5 text-emerald-400"
              />
              مسابقات به‌روز
            </span>

            <span className="flex items-center gap-2">
              <Icon
                name="news"
                className="h-3.5 w-3.5 text-amber-400"
              />
              اخبار رسمی
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}